import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Contenido from "./components/Contenido";
import { Services } from "./components/services";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { db } from "./firebaseConfig";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [info, setInfo] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [paquetes, setPaquetes] = useState([]);
  const [categoriasLista, setCategoriasLista] = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);

  useEffect(() => {
    setLandingPageData(JsonData);
    traerData();
    traerPaquetes();
    traerCategorias();
    traerSubcategorias();
  }, []);

  useEffect(() => {
    armarCategorias();
  }, [paquetes, categoriasLista, subcategorias]);

  let armarCategorias = async () => {
    let cates = [...categoriasLista];

    cates.forEach(cat => {
      subcategorias.forEach(sub => {
        cat.subcategorias.push({...sub});
      })
    });

    cates.forEach(cat => {
      cat.subcategorias.forEach(sub => {
        let paques = paquetes.filter(paq => {
          return paq.idCategoria === cat.id && paq.idSubcategoria === sub.id
        })
        sub.paquetes = [...paques];
      })
    })
    setCategorias(cates);
  }

  let traerPaquetes = () => {
    db.collection('paquetes').orderBy('precio').onSnapshot(snap => {
      let paques = [];
      snap.forEach(doc => {
        let obj = { ...doc.data(), id: doc.id };
        paques.push(obj);
      });
      setPaquetes(paques);
    });
  }

  let traerCategorias = () => {
    db.collection('categorias').orderBy('orden')
    .onSnapshot(snap => {
      let cates = [];
      snap.forEach(doc => {
        let obj = { ...doc.data(), id: doc.id, subcategorias: [] };
        cates.push(obj);
      });
      setCategoriasLista(cates)
    });
  }

  let traerSubcategorias = () => {
    db.collection('subcategorias').orderBy('orden')
    .onSnapshot(snap => {
      let subcates = [];
      snap.forEach(doc => {
        let obj = { ...doc.data(), id: doc.id, paquetes: [] };
        subcates.push(obj);
      });
      setSubcategorias(subcates)
    });
  }

  let traerData = () => {
    db.collection("dataWeb").onSnapshot((snap) => {
      let inf = [];
      snap.forEach((doc) => {
        inf[doc.id] = doc.data();
      });
      setInfo(inf);
      console.log(inf);
    });
  };

  return (
    <div>
      <Router>
        <Contenido landingPageData={landingPageData} info={info} categorias={categorias} />
      </Router>
    </div>
  );
};

export default App;
